module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-4-3271dc16a785385f28d37125e8adff7a.jpg";